import apiConfig from '../../../../../../../config/api'
import { apiRequestorHelper } from '../../../../../../../helpers'

export const getAlertByRiskService = (dateRange) => {
	return apiRequestorHelper({
		url: apiConfig.url + '/transaction/indicators/getResumeAlertByRisk',
		method: 'post',
    body: {dateRange}
	})
}